import React, { useState, useRef, useEffect, useCallback } from "react";
import PinkButton from "../component/PinkButton";
import CarImageForm from "../component/CarImageForm";
import TopInfo from "../component/TopInfo";
import layout_text from "../assets/json/layout_text.json";
import Celebration from "../assets/img/celebration.png";
import Relax from "../assets/img/relax.png";
import Odometer from "../assets/img/odometer.png";
import Step_1 from "../assets/img/step_1_banner.png";
import Step_2 from "../assets/img/step_2_banner.png";
import Step_3 from "../assets/img/step_3_banner.png";
import CarIcon from "../assets/img/car.png";

import { useQuery } from "../hooks/useQuery";
import { useParams, useLocation } from "react-router-dom";
import { FileInput } from "../component/Inputs";
import { submitCarPictures, getStatus } from "../hooks/apiCalls";

const Progress = () => {
  let { step_no } = useParams();
  let query = useQuery();
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [popup, setPopup] = useState(false);
  const [preCarImages, setPreCarImages] = useState({
    car_front: "",
    car_back: "",
    car_left: "",
    car_right: "",
    odometer: "",
    odometer_number: 0,
  });
  const [postCarImages, setPostCarImages] = useState({
    car_front: "",
    car_back: "",
    car_left: "",
    car_right: "",
  });
  const [appointmentDetails, setAppointmentDetails] = useState({
    name: "",
    booking_id: "",
    car_brand_model: "",
    installer_workshop: "",
    campaign: "",
    appointment_datetime: "",
  });

  const [hasError, setHasError] = useState(false);
  const [hasRead, setHasRead] = useState(false);
  const [showHasReadError, setShowHasReadError] = useState(false);

  const wrapperRef = useRef(null);

  const handleFile = (name) => {};

  useEffect(() => {
    if (step_no) {
      setStep(parseInt(step_no));
    }

    if (!query.get("userAuth")) {
    }

    handleGetStatus();
  }, []);

  const useOutsideAlerter = useCallback(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        // alert("You clicked outside of me!");
        setPopup(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  const handleGetStatus = async () => {
    var status = await getStatus({
      bearerToken: query.get("userAuth"),
    });

    if (status.data) {
      const { user, booking, car, workshop, campaign } = status.data.data;
      setAppointmentDetails({
        name: `${user.fname} ${user.lname}`,
        booking_id: `booking #${booking.id}`,
        car_brand_model: `${car.brand} ${car.model} ${
          car.year ? car.year : ""
        } ${car.color}`,
        installer_workshop: `Installer ${workshop.name}`,
        campaign: `${campaign.brand} - ${campaign.title}`,
        appointment_datetime: `${booking.date} ${booking.time}`,
      });

      switch (booking.status) {
        case "Confirmed":
          setStep(0);
          break;
        case "Installing":
          setStep(2);
          break;
        case "Ready":
          setStep(3);
          break;
      }
    }
  };

  const handleNext = async () => {
    let err = false;
    switch (step) {
      case 0:
        //step 1
        Object.keys(preCarImages).forEach((image) => {
          if (image !== "odometer") {
            if (preCarImages[image] == "") {
              err = true;
            }
          }
        });
        setHasError(err);

        if (!err) {
          setStep(step + 1);
        }

        break;
      case 1:
        //step 2
        if (preCarImages.odometer === "" || preCarImages.odometer_number <= 0) {
          err = true;
        }

        setHasError(err);

        if (!err) {
          setPopup(true);
        }
        break;
      case 3:
        //step 4
        Object.keys(postCarImages).forEach((image) => {
          if (postCarImages[image] == "") {
            err = true;
          }
        });
        setHasError(err);

        if (!err) {
          setPopup(true);
        }
        break;
    }
  };

  const handleTnCSubmit = async () => {
    if (hasRead) {
      setShowHasReadError(false);
      if (step == 1) {
        await handlePreSubmit();
      }
      if (step == 3) {
        await handlePostSubmit();
      }
    } else {
      setShowHasReadError(true);
    }
  };

  const handlePreSubmit = async () => {
    setIsLoading(true);
    var response = await submitCarPictures({
      pictures: {
        pre_car_front: preCarImages.car_front,
        pre_car_back: preCarImages.car_back,
        pre_car_left: preCarImages.car_left,
        pre_car_right: preCarImages.car_right,
        odometer: preCarImages.odometer,
        odometer_number: preCarImages.odometer_number,
      },
      bearerToken: query.get("userAuth"),
    });

    if (response.data.success) {
      setStep(step + 1);
      setPopup(false);
      setIsLoading(false);
    } else {
      console.log("error", response);
      setIsLoading(false);
    }
  };

  const handlePostSubmit = async () => {
    setIsLoading(true);
    var response = await submitCarPictures({
      pictures: {
        post_car_front: postCarImages.car_front,
        post_car_back: postCarImages.car_back,
        post_car_left: postCarImages.car_left,
        post_car_right: postCarImages.car_right,
      },
      bearerToken: query.get("userAuth"),
    });

    if (response.data.success) {
      setStep(step + 1);
      setPopup(false);
      setIsLoading(false);
    } else {
      console.log("error", response);
      setIsLoading(false);
    }
  };
  const preConstant = [
    "I am the owner of this car and have the right to drive this car as per the supporting documents provided to carching.",
    `My car's exterior body and paint are in good condition (e.g. no dents, scratches, paint chips, resprayed, etc.)`,
    "I understand and accept that there are risks involved in styling my car, especially if the exterior of my car has defects or not the original paint. ",
    "The exterior of my car has been washed and cleaned right before the installation. ",
    "I did not leave behind any valuable belonging in the car for the installation process.",
    "I will abide by the laws of country while driving.",
    "I will abide the requirements of the campaign and the brand ambassador agreement.",
  ];
  const postConstant = [
    "I accept the quality of the installation on and the condition of my car.",
    `The brand assets will be placed on my car throughout the campaign and will not be removed until the end of the campaign scheduled with carching's authorised partner. `,
    `I will drive responsibly, obey the rules and regulations and represent the brand the best as I can (e.g.  stop at red, no double parking, speeding, cutting queues, will not park at flood-prone areas, road rage, drink and drive etc. )`,
    "I commit to drive for entire period of the campaign and that there will be little to no disruption to my daily driving routine.",
    "I understand that there will be penalties and charges for any last minute changes or withdrawal from the campaign",
  ];
  useOutsideAlerter(wrapperRef);
  // useOutsideAlerter()
  return (
    <>
      {query.get("userAuth") ? (
        <div className="min-h-screen flex flex-col">
          {popup && (
            <div className="w-full h-screen backdrop-blur-sm bg-white/30 z-10 absolute top-0 left-0 p-5 flex justify-center items-center">
              <div
                className="bg-white p-5 rounded-xl shadow-lg w-full"
                ref={wrapperRef}
              >
                <div className="mb-2">
                  <p className="text-carching-pink">I confirm that</p>
                </div>
                {step === 1 ? (
                  <>
                    {preConstant.map((value) => (
                      <div
                        className="mb-2"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={CarIcon}
                          alt=""
                          style={{
                            height: "40px",
                            width: "40px",
                            marginRight: "5px",
                          }}
                        />
                        <p
                          className="text-carching-pink"
                          style={{
                            fontSize: "13px",

                            fontFamily: "Roboto",
                          }}
                        >
                          {value}
                        </p>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {postConstant.map((value) => (
                      <div
                        className="mb-2"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={CarIcon}
                          alt=""
                          style={{
                            height: "40px",
                            width: "40px",
                            marginRight: "5px",
                          }}
                        />
                        <p
                          className="text-carching-pink"
                          style={{
                            fontSize: "13px",

                            fontFamily: "Roboto",
                          }}
                        >
                          {value}
                        </p>
                      </div>
                    ))}
                  </>
                )}

                <div class="w-full flex items-center mb-2">
                  <input
                    type="checkbox"
                    class="checked:bg-blue-500 mr-2 cursor-pointer"
                    id="tnc-agree"
                    checked={hasRead}
                    onChange={() => setHasRead(!hasRead)}
                  />
                  <label
                    htmlFor="tnc-agree"
                    className="cursor-pointer"
                    style={{
                      fontFamily: "Roboto",
                      fontWeight: "bold",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    I accept the above and agree to be part of this campaign for
                    the stated period.
                  </label>
                </div>
                {showHasReadError && (
                  <p className="text-red-500 mb-2">
                    Please agree to the terms and conditions
                  </p>
                )}
                <PinkButton
                  text="Confirm"
                  loading={isLoading}
                  onClick={() => handleTnCSubmit()}
                />
              </div>
            </div>
          )}
          <TopInfo appointmentDetails={appointmentDetails} />
          <div className="p-4 flex-1 flex flex-col justify-center items-center">
            <div className="w-full flex justify-center">
              {(step == 0 || step == 1) && <img src={Step_1} alt="" />}

              {step == 2 && <img src={Step_2} alt="" />}

              {(step == 3 || step == 4) && <img src={Step_3} alt="" />}
            </div>
            <div className="top flex-1 flex">
              {step == 0 && (
                <CarImageForm get={preCarImages} set={setPreCarImages} />
              )}

              {step == 1 && (
                <div className="flex-1 flex items-center justify-center flex-col">
                  <img src={Odometer} alt="" className="mb-8" />
                  <FileInput
                    name="odometer"
                    label="Odometer"
                    onChange={({ converted }) =>
                      setPreCarImages({ ...preCarImages, odometer: converted })
                    }
                  />
                  <br />
                  <div>
                    <label
                      htmlFor="price"
                      className="block text-sm font-medium leading-6 text-carching-pink"
                    >
                      Odometer Number(km)
                    </label>
                    <div className="relative mt-2 rounded-md shadow-sm">
                      <input
                        type="number"
                        name="odometer_number"
                        id="odometer_number"
                        className="block w-full rounded-md border-0 py-1.5 pl-7 pr-20 text-carching-pink ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        placeholder="1000 (km)"
                        onChange={(e) => {
                          setPreCarImages({
                            ...preCarImages,
                            odometer_number: Number(e.target.value),
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
              {step == 2 && (
                <div className="w-full flex flex-col justify-center items-center flex-1">
                  <p className="text-carching-pink mb-4 text-xl">
                    Installation in progress.
                  </p>
                  <p className="text-carching-pink mb-20 text-xl">
                    It will take approximately 1.5 to 2 hours.
                  </p>
                  <img src={Relax} alt="" />
                </div>
              )}

              {step == 3 && (
                <CarImageForm get={postCarImages} set={setPostCarImages} />
              )}

              {step == 4 && (
                <div className="w-full flex flex-col justify-center items-center flex-1 text-xl">
                  <img src={Celebration} alt="" />
                  <p className="text-carching-pink mt-20 text-center">
                    Welcome onboard!
                  </p>
                  <p className="text-carching-pink mt-4 text-center">
                    The campaign will start in awhile.
                  </p>

                  <p className="text-carching-pink mt-4 text-center">
                    Let's start turning your <br /> KM into RM!
                  </p>
                </div>
              )}
            </div>

            <div className="page-bottom w-full max-w-lg">
              <div className="text-center mb-4">
                <p
                  className={`text-xl transition ${
                    hasError
                      ? "animate-bounce-fast duration-100 text-red-600"
                      : "text-carching-pink "
                  }`}
                >
                  {layout_text[step].bottom}
                </p>
              </div>

              {layout_text[step].button_text ? (
                <>
                  {step !== 4 && (
                    <PinkButton
                      text="Next"
                      loading={isLoading}
                      onClick={(e) => handleNext(e)}
                    />
                  )}
                </>
              ) : (
                <div className="p-2 py-4"></div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div class="w-full flex justify-center items-center min-h-screen">
          <p>something went wrong</p>
        </div>
      )}
    </>
  );
};

export default Progress;
